import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = ({noPlan = false}) => {

  return (
        <div className="support-info">
            <p className='support'>Customer Support:</p>
            <div className='cdetails'>
                <p className='phone'>1800 572 3861</p>
                <p>|</p>
                <p className='email'>support@globalassure.com</p>
            </div>
            {!noPlan && (
                <div className='goto-home'>
                    <Link to="/" className="orders-link">Go to Home Page</Link>
                </div>
            )}
        </div>
    );
};

export default Footer;
